import React from "react";
import Modal from "../../../Common/Modal";
import ListItem from "../partails/ListItem";
import CommonButton from "../../../Buttons/CommonButton";
import InitialsAvatar from "../../../Common/InitialsAvatar";
import { useNavigate } from "react-router-dom";
import { useCurrencies } from "../../../../hooks";

const ShowBeneficiaryModal = ({ isModalOpen, setIsModalOpen, beneficiary }) => {
  const navigate = useNavigate();
  const currencies = useCurrencies('fiat');
  
  const clientAccounts = React.useMemo(() => {
    const clientInfo = JSON.parse(localStorage.getItem("clientInfo") || "{}");
    return clientInfo.accounts || [];
  }, []);

  // Display the transfer button only if the client has an account in the beneficiary's currency.
  const hasAccountCurrency = (currencyId) => clientAccounts.some((acc) => acc.currency_id === currencyId);
  const canTransfer = !beneficiary.is_sepa || hasAccountCurrency(beneficiary.account_currency);
  
  const getCurrencyLogo = (currencyId) => {
    const currency = currencies.find((c) => c.id === currencyId);
    return currency?.logo || "";
  };

  const handleTransfer = () => {
    navigate("/transfer", {
      state: { beneficiary, type: "transfer" },
    });
  };

  const formateVirtualBankDetails = (virtualBankBeneficiary) => {

    // Parse routing codes safely
    let routingCodes = virtualBankBeneficiary?.bank_routing_codes;

    if (typeof routingCodes === "string") {
      try {
        const parsed = JSON.parse(routingCodes);

        // normalize single object → array
        routingCodes = Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        routingCodes = [];
      }
    }

    // Normalize keys (backend vs frontend mismatch fix)
    const routingNumber =
      routingCodes?.find(
        (code) =>
          code.routingCodeKey === "ROUTING_NUMBER" ||
          code.type === "routing_number"
      )?.routingCodeValue ||
      routingCodes?.find(
        (code) =>
          code.routingCodeKey === "SORT_CODE" ||
          code.type === "sort_code"
      )?.routingCodeValue;

    return (
      <>
        <ListItem
          title="Virtual Bank Account Number"
          value={virtualBankBeneficiary?.account_number || "-"}
        />
        <ListItem
          title="Routing Number"
          value={routingNumber || "-"}
        />
      </>
    );
  };

  return (
    <Modal
      isOpen={isModalOpen}
      handleOnCloseModal={() => setIsModalOpen(false)}
      header={true}
      headerTitle={"Beneficiary Details"}
      className="bg-background-surface w-[432px] max-h-[740px] overflow-scroll hide-scrollbar rounded-3xl"
    >
      <div className="px-6">
        <div className="flex items-center space-x-3 py-4">
          <InitialsAvatar name={beneficiary.name} />
          <div className="text-text-primary text-base font-medium tracking-tight">
            {beneficiary.name}
          </div>
        </div>

        <hr className="mb-4 border border-background-secondary dark:border-divider" />
        <div className="flex flex-col pb-4">
          <ListItem title="Account Number" value={beneficiary.account_number} />
          <ListItem title="IBAN" value={beneficiary.iban} />
          {beneficiary.account_currency && (
            <ListItem
              title="Beneficiary account currency"
              value={
                <span className="flex space-x-3 items-center justify-center">
                  <img
                    className="h-6 w-6"
                    src={getCurrencyLogo(beneficiary.account_currency)}
                    alt="currency_logo"
                  />
                </span>
              }
            />
          )}
          <ListItem title="Full Name" value={beneficiary.name} />
          <ListItem title="Beneficiary Address" value={beneficiary.address} />
          <ListItem title="Bank Name" value={beneficiary.bank_name} />
          <ListItem title="Swift Code" value={beneficiary.swift_code} />
          <ListItem title="Bank Address" value={beneficiary.bank_address} />
          
          {(beneficiary.is_sepa && beneficiary.virtual_bank_beneficiary ) ? 
            (formateVirtualBankDetails(beneficiary.virtual_bank_beneficiary)) : ""
          }

        </div>
        {canTransfer && (
          <div className="pb-6">
            <CommonButton onClick={handleTransfer}>
              Transfer amount
            </CommonButton>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ShowBeneficiaryModal;
